import React from "react";
import Nav from "../components/landing/Nav";
import Hero from "../components/landing/Hero";
import Heritage from "../components/landing/Heritage";
import Marquee from "../components/landing/Marquee";
import Odoc from "../components/landing/Odoc";
import MenuShowcase from "../components/landing/MenuShowcase";
import Turnkey from "../components/landing/Turnkey";
import Financials from "../components/landing/Financials";
import PremiumPlan from "../components/landing/PremiumPlan";
import ApplicationForm from "../components/landing/ApplicationForm";
import FAQ from "../components/landing/FAQ";
import Footer from "../components/landing/Footer";
import { content } from "../content";

export default function LandingPage({ lang, setLang }) {
  const t = content[lang];
  return (
    <div className="bg-stone-base text-stone-50 min-h-screen" data-testid="landing-page">
      <Nav t={t} lang={lang} setLang={setLang} />
      <main>
        <Hero t={t.hero} />
        <Heritage t={t.heritage} />
        <Marquee items={t.marquee} />
        <Odoc t={t.odoc} />
        <MenuShowcase t={t.menu} />
        <Turnkey t={t.turnkey} />
        <Financials t={t.financials} />
        <PremiumPlan t={t.premium} />
        <ApplicationForm t={t.form} />
        <FAQ t={t.faq} />
      </main>
      <Footer t={t.footer} />
    </div>
  );
}
